<template>
  <div>
    <div
      class="mb-8 body1"
      data-testid="ticket-confirmation-text"
      v-html="localValue?.item.text"
    ></div>
    <v-checkbox
      v-if="localValue.item.showCheckbox"
      v-model="localValue.item.closeTicket"
      data-testid="ticket-confirmation-checkbox"
    >
      <template #label>
        <div class="body1">{{ checkboxText }}</div>
      </template>
    </v-checkbox>
    <div
      v-if="localValue.item.showCheckbox && localValue.item.checkboxDescription"
      class="body2 checkbox-description mt-2"
      data-testid="ticket-confirmation-checkbox-description"
      v-html="localValue.item.checkboxDescription"
    />
  </div>
</template>

<script lang="ts">
import cloneDeep from "lodash/cloneDeep";
import { computed, defineComponent, onMounted, type PropType, ref, watch } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  emits: ["update:localValue"],
  setup(props, { emit }) {
    const localValue = ref({
      item: {
        checkboxText: "",
        closeTicket: false,
        text: "",
        showCheckbox: false,
        checkboxDescription: "",
      },
    } as DialogDataConfig);
    const checkboxText = computed(() => props?.config?.item.checkboxText);

    watch(
      localValue.value,
      (newVal: DialogDataConfig) => {
        emit("update:localValue", newVal);
      },
      { deep: true }
    );

    onMounted(() => {
      localValue.value = cloneDeep(props.config);
      emit("update:localValue", localValue.value);
    });

    return {
      checkboxText,
      localValue,
    };
  },
});
</script>

<style lang="scss" scoped>
.checkbox-description {
  color: rgb(var(--v-theme-indigo-medium));
}
</style>
